import { render, staticRenderFns } from "./BaseInputSearch.vue?vue&type=template&id=ed5c64da&scoped=true&"
import script from "./BaseInputSearch.vue?vue&type=script&lang=js&"
export * from "./BaseInputSearch.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputSearch.vue?vue&type=style&index=0&id=ed5c64da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5c64da",
  null
  
)

export default component.exports